import { SectionHeader } from '../rows/SectionHeader'
import type { MonthMetrics } from '@/features/history/types'

interface ClientsSectionProps {
  metrics: MonthMetrics
  formatNumber: (v: number) => string
}

export function ClientsSection({ metrics, formatNumber }: ClientsSectionProps) {
  return (
    <>
      <SectionHeader label="Клиенты" color="blue" />
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm">Клиентов (начало → конец)</td>
        <td className="p-3 text-right font-mono text-sm text-muted-foreground">-</td>
        <td className="p-3 text-right font-mono text-sm text-muted-foreground">-</td>
        <td className="p-3 text-right font-mono text-sm">{formatNumber(metrics.clients_at_start.plan)}</td>
        <td className="p-3 text-right font-mono text-sm font-semibold">{formatNumber(metrics.clients_at_end.fact)}</td>
        <td className="p-3 text-center text-muted-foreground">-</td>
      </tr>
    </>
  )
}
